import { styled } from '@mui/material/styles';

export const DatePickerWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  '& .react-datepicker-popper': {
    zIndex: 15,
  },
}));


